import React from "react"

const StarSecondary = ({ smaller }) => {
  return smaller ? (
    <svg
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.65567 0.878115C5.74548 0.601722 6.1365 0.601722 6.22631 0.878115L7.24693 4.01929C7.2871 4.1429 7.40228 4.22658 7.53225 4.22658H10.8351C11.1257 4.22658 11.2465 4.59847 11.0114 4.76929L8.33937 6.71064C8.23422 6.78703 8.19023 6.92244 8.23039 7.04605L9.25102 10.1872C9.34082 10.4636 9.02448 10.6935 8.78937 10.5226L6.11732 8.58128C6.01218 8.50489 5.8698 8.50489 5.76465 8.58128L3.09261 10.5226C2.8575 10.6935 2.54115 10.4636 2.63096 10.1872L3.65159 7.04605C3.69175 6.92244 3.64775 6.78703 3.54261 6.71064L0.870564 4.76929C0.63545 4.59847 0.756283 4.22658 1.0469 4.22658H4.34973C4.47969 4.22658 4.59488 4.1429 4.63504 4.01929L5.65567 0.878115Z"
        fill="#BFBFBF"
      />
    </svg>
  ) : (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7147 0.878115C10.8045 0.601722 11.1955 0.601722 11.2853 0.878115L13.6268 8.0845C13.667 8.20811 13.7822 8.2918 13.9121 8.2918H21.4894C21.78 8.2918 21.9008 8.66368 21.6657 8.8345L15.5356 13.2883C15.4304 13.3647 15.3864 13.5001 15.4266 13.6237L17.7681 20.8301C17.8579 21.1065 17.5416 21.3363 17.3065 21.1655L11.1763 16.7117C11.0712 16.6353 10.9288 16.6353 10.8237 16.7117L4.69355 21.1655C4.45843 21.3363 4.14209 21.1065 4.23189 20.8301L6.57339 13.6237C6.61355 13.5001 6.56956 13.3647 6.46441 13.2883L0.334292 8.8345C0.0991777 8.66368 0.22001 8.2918 0.510627 8.2918H8.08787C8.21784 8.2918 8.33302 8.20811 8.37319 8.0845L10.7147 0.878115Z"
        fill="#BFBFBF"
      />
    </svg>
  )
}

export default StarSecondary
